import axiosInstance from './axiosInstance';

export const mapBestProductsSection = (s) => {
  if (!s) return null;
  return {
    label: s.label ?? '',
    title: s.title ?? 'Best Products',
    subtitle: s.subtitle ?? '',
    ctaLabel: s.cta_label ?? s.ctaLabel ?? 'View All Products',
    ctaUrl: s.cta_url ?? s.ctaUrl ?? '/products',
    isActive: Boolean(s.is_active ?? s.isActive ?? true),
  };
};

export const mapBestProductTab = (t) => {
  if (!t) return null;
  return {
    id: t.id,
    name: t.name ?? '',
    slug: t.slug ?? '',
    categoryId: t.category_id ?? t.categoryId ?? null,
    sortOrder: Number(t.sort_order ?? t.sortOrder ?? 0),
    isActive: Boolean(t.is_active ?? t.isActive ?? true),
    productIds: Array.isArray(t.productIds)
      ? t.productIds
      : Array.isArray(t.product_ids)
        ? t.product_ids
        : [],
  };
};

export const fetchBestProductsSection = async () => {
  const response = await axiosInstance.get('/best-products/section');
  return mapBestProductsSection(response.data);
};

export const updateBestProductsSection = async (payload) => {
  const response = await axiosInstance.put('/best-products/section', {
    label: payload.label,
    title: payload.title,
    subtitle: payload.subtitle,
    cta_label: payload.ctaLabel,
    cta_url: payload.ctaUrl,
    is_active: String(Boolean(payload.isActive)),
  });
  return response.data;
};

export const fetchBestProductTabs = async () => {
  const response = await axiosInstance.get('/best-products/tabs');
  const list = Array.isArray(response.data) ? response.data : [];
  return list.map(mapBestProductTab).filter(Boolean);
};

export const createBestProductTab = async (payload) => {
  const response = await axiosInstance.post('/best-products/tabs', {
    name: payload.name,
    slug: payload.slug || undefined,
    category_id: payload.categoryId || null,
    sort_order: String(payload.sortOrder ?? 0),
    is_active: String(Boolean(payload.isActive ?? true)),
  });
  return response.data;
};

export const updateBestProductTab = async (id, payload) => {
  const response = await axiosInstance.put(`/best-products/tabs/${id}`, {
    name: payload.name,
    slug: payload.slug,
    category_id: payload.categoryId ?? null,
    sort_order: payload.sortOrder !== undefined ? String(payload.sortOrder) : undefined,
    is_active: payload.isActive !== undefined ? String(Boolean(payload.isActive)) : undefined,
  });
  return response.data;
};

export const deleteBestProductTab = async (id) => {
  await axiosInstance.delete(`/best-products/tabs/${id}`);
};

export const setBestProductTabProducts = async (tabId, productIds) => {
  const response = await axiosInstance.put(`/best-products/tabs/${tabId}/products`, {
    productIds,
  });
  return response.data;
};
